"use client";

import { motion, useReducedMotion } from "framer-motion";
export default function Distilleryintro() {
  const reduce = useReducedMotion();
  const headlineText = "Especialistas em sistemas de engenharia e pulverização industrial.";
  const words = headlineText.split(" ");
  const wordVariants = {
    hidden: reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 24,
      filter: "blur(14px)"
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1] as const
      }
    }
  };
  return <section data-section-id="31277" id="distilleryintro" data-nav="dark" className="relative overflow-hidden bg-primary text-primary-foreground pt-[200px] pb-[clamp(120px,14vh,180px)]" style={{
    backgroundImage: "radial-gradient(circle at 10% 30%, hsl(215 90% 45% / 0.28), hsl(215 80% 20%) 60%)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-1/4 h-[720px] w-[720px] rounded-lg opacity-60 blur-3xl" style={{
      background: "radial-gradient(circle, hsl(215 90% 45% / 0.35), transparent 70%)"
    }} />

      <div className="relative mx-auto w-full max-w-[1360px] px-[clamp(20px,4vw,64px)]">
        {}
        <div className="grid grid-cols-1 gap-y-12 lg:grid-cols-12 lg:gap-x-8">
          {}
          <div className="lg:col-span-8">
            <motion.p initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.6
          }} transition={{
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className="font-default text-[clamp(0.68rem,0.72vw,0.78rem)] font-medium uppercase" style={{
            letterSpacing: "0.22em",
            color: "hsl(215 90% 75%)"
          }}>
              A nossa missão
            </motion.p>

            <div className="mt-10 relative">
              {}
              <div aria-hidden="true" className="pointer-events-none absolute left-[10%] top-1/3 h-[380px] w-[70%] rounded-lg opacity-40 blur-3xl" style={{
              background: "radial-gradient(ellipse, hsl(215 90% 45% / 0.55), transparent 70%)"
            }} />
              <motion.h1 initial="hidden" whileInView="visible" viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              staggerChildren: 0.06
            }} className="relative font-default text-[clamp(3.5rem,8.4vw,8.75rem)] font-normal" style={{
              letterSpacing: "-0.035em",
              lineHeight: 0.94,
              color: "hsl(210 20% 98%)"
            }}><span data-index="0" className="inline-block mr-[0.25em]" data-ast-id="f:/src/pages/Distillery/sections/Distilleryintro.tsx|sig:ka8l2t" data-ast-start="3001" data-ast-end="3257" data-array-file="/src/pages/Distillery/sections/Distilleryintro.tsx" data-array-name="words" data-array-start-line="88" data-array-end-line="88" data-is-from-array="true" data-is-nested-array="false" data-attr-property-mappings="key:i,data-index:i,variants:wordVariants" data-array-index="0" style={{
                opacity: '1',
                filter: 'blur(0px)',
                transform: 'none'
              }} contenteditable="false">Tecnologia de Pulverização para a Indústria de Destilação</span></motion.h1>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 lg:flex lg:flex-col lg:justify-end lg:pb-2">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.72,
            delay: reduce ? 0 : 0.4,
            ease: [0.22, 1, 0.36, 1]
          }}>
              <p className="font-default text-[clamp(1.05rem,1.15vw,1.25rem)] font-light" style={{
              lineHeight: 1.55,
              letterSpacing: "-0.005em",
              color: "hsl(210 20% 98% / 0.85)"
            }}>A Spraying Systems Co. disponibiliza tecnologia de pulverização e expertise de aplicação para destilarias e unidades de produção de bebidas espirituosas. Desde recipientes de fermentação e alambiques até linhas de engarrafamento e zonas de lavagem, as nossas soluções ajudam as destilarias a melhorar o desempenho de limpeza, reduzir o consumo de água e de produtos químicos, proteger a qualidade do produto e manter a produção em movimento.</p>
              <p className="mt-8 font-default text-[clamp(0.82rem,0.85vw,0.9rem)]" style={{
              letterSpacing: "0.02em",
              lineHeight: 1.45,
              color: "hsl(215 12% 70%)"
            }}>
                Desde 1937 · Especialistas em pulverização · Parceiros de confiança.
              </p>
            </motion.div>
          </div>
        </div>

        {}
        <motion.div initial={{
        opacity: 0,
        y: 32
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.9,
        delay: reduce ? 0 : 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mt-[120px] overflow-hidden rounded-3xl" style={{
        border: "1px solid hsl(210 20% 98% / 0.08)",
        boxShadow: "inset 0 1px 0 hsl(210 20% 98% / 0.14)"
      }}>
          <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/industrial_spraying_system.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/industrial_spraying_system.png-wvc-sizes" alt="Sistema de pulverização industrial de alta precisão em ambiente fabril" loading="lazy" decoding="async" className="w-full h-[clamp(320px,60vh,640px)] object-cover" src="https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-05-as-17.43.27.png" />
          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
          background: "radial-gradient(circle at 30% 50%, hsl(215 90% 45% / 0.15), transparent 60%)"
        }} />
        </motion.div>
      </div>
    </section>;
}